import React from 'react';
import PDFContainer from '../../Containers/PDFContainer';


const PDFList = (props) => {
	return (
		<PDFContainer page="pdList"/>
	);

}

export default PDFList;

